import { Text, colors, formatKm } from '@khaddi/ui';
import { View } from 'react-native';

type Stop = { caption: string; title: string };

/** Pickup → dropoff with the dashed connector from the design. */
export const RouteLine = ({ pickup, dropoff }: { pickup: Stop; dropoff: Stop }) => (
  <View style={{ flexDirection: 'row', gap: 12 }}>
    <View style={{ alignItems: 'center', paddingTop: 4 }}>
      <View style={{ width: 14, height: 14, borderRadius: 7, backgroundColor: colors.navy, borderWidth: 3, borderColor: colors.gold }} />
      <View style={{ width: 2, flex: 1, marginVertical: 4, borderLeftWidth: 2, borderStyle: 'dashed', borderColor: colors.sky }} />
      <View style={{ width: 14, height: 14, borderRadius: 7, backgroundColor: colors.red }} />
    </View>
    <View style={{ flex: 1, gap: 14 }}>
      <View>
        <Text variant="caption">{pickup.caption}</Text>
        <Text variant="bodyStrong">{pickup.title}</Text>
      </View>
      <View>
        <Text variant="caption">{dropoff.caption}</Text>
        <Text variant="bodyStrong">{dropoff.title}</Text>
      </View>
    </View>
  </View>
);

export const kmCaption = (prefix: string, km: number): string => `${prefix} · ${formatKm(km)}`;
